module.exports = __webpack_public_path__ + "static/F3_bg_mobile_frame-3c84d9e6af41edbb334c5ad561f38a0a.png";